import { Link } from "react-router-dom";

function Explore () { 
    return(
    <>
        {/* <!-- =============page banner==================== -->*/}
    <div className="page-banner">
        <div className="container">
            <div className="page-banner-content">
                <div className="banner-inner">
                    <h2>About</h2>
                    <div className="page-route">
                        <a href="">Home </a>
                        <p> / About </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/*
    <!-- =============page banner end================ -->*/} 
    {/* ====================top collection=================== */}
    <div className="top-collection cpt-6">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                        <div className="filtaring-category">
                                <div className="filter-btn">
                                    <div class="select">
                                        <select className="select-box">
                                            <option value="1" selected>All categories</option>
                                            <option value="2">No JS</option>
                                            <option value="3">Nice!</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="filter-btn">
                                    <div class="select">
                                        <select className="select-box">
                                            <option value="1" selected>Buy Now</option>
                                            <option value="2">No JS</option>
                                            <option value="3">Nice!</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="filter-btn">
                                    <div class="select">
                                        <select className="select-box">
                                            <option value="1" selected>All Items</option>
                                            <option value="2">No JS</option>
                                            <option value="3">Nice!</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="sort-by">
                            <div className="filter-btn">
                                    <div class="select">
                                        <select className="select-box">
                                            <option value="1" selected>All Artworks</option>
                                            <option value="2">No JS</option>
                                            <option value="3">Nice!</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="filter-btn">
                                    <div class="select">
                                        <select className="select-box">
                                            <option value="1" selected>Sort by</option>
                                            <option value="2">No JS</option>
                                            <option value="3">Nice!</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="top-collection-arefa cpy-5">
                        <div className="top-collection-slider">
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="load-more-area mt-4"><a href="" class="custom-btn"><span>Load More</span></a></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ====================top collection end =================== */}
    </> 
    ); 
} 
    
export default Explore;